<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Cpb1PJ/tc-custom/9781504004817.jpg?1706123563603" alt="This image is the cover for the book One Foot in the Grave, The James Pibble Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">One Foot in the Grave, The James Pibble Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>CWA Gold Dagger winner Peter Dickinson is back: Now-retired Scotland Yard superintendent James Pibble isn’t about to go quietly into the night—not when there’s a murder case or two (or three) to solve </b><br/><br/> At Flycatchers, a well-to-do nursing home watched over by no-nonsense nurse Jenny, one-time detective James Pibble shuttles between his nothing-to-live-for present and memories of the crimes he’s solved—or failed to. He’s roused from his listless existence when he discovers a dead body on top of the water tower.<br/><br/> Security guard George Tosca isn’t the only one at Flycatchers who has met his maker a bit too abruptly. There have been other suspicious deaths in the last three years, including those of military man Sir Archibald Gunter and Bertie Foster-Banks, an inveterate gambler and shareholder in the home. The arrival of a woman in black sets off a sinister chain of events, and before he knows it, Pibble is on the case.<br/><br/> As he travels down a twisting path of blackmail and escalating violence, Pibble finds that his life is suddenly filled with purpose again. He will bring a cunning killer to justice—or die trying. But the real reason he went up to the tower on that stormy winter night is linked to a secret he’ll carry to his grave.<br/><br/> One Foot in the Grave <i>is the 6th book in the James Pibble Mysteries, but you may enjoy reading the series in any order.</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Peter Dickinson
      </h2>
      
      <p class="authorDescription body article">Peter Dickinson was born in Africa but raised and educated in England. From 1952 to 1969 he was on the editorial staff of&#160;<I>Punch</I>,&#160;and since then has earned his living writing fiction of various kinds for children and adults. His books have been published in several languages throughout the world.<BR /><BR /> The recipient of many awards, Dickinson has been shortlisted nine times for the prestigious Carnegie Medal for children&rsquo;s literature and was the first author to win it twice.&#160;The author of twenty-one crime and mystery novels for adults, Dickinson was also the first to win the Gold Dagger of the Crime Writers&rsquo; Association for two books running: <I>The Glass-Sided Ants&rsquo; Nest</I> (1968) and&#160;<I>The Old English Peepshow</I> (1969).<BR /><BR /> A collection of Dickinson&rsquo;s poetry,&#160;<I>The Weir</I>, was published in 2007.&#160;His latest book,&#160;<I>In the Palace of the Khans</I>,&#160;was published in 2012 and was nominated for the Carnegie Medal.<BR /><BR /> Dickinson has served as chairman of the Society of Authors and is a fellow of the Royal Society of Literature.&#160;He was made an Officer of the Order of the British Empire in 2009 for services to literature.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1e93e138